import React, { Fragment } from "react";

const RecommendedUsers = () => {
  return (
    <Fragment>
      <div className="online-recommended">
        <div className="online-title-container-alt">
          <div className="border-alt green">
            <p className="online-title-alt green">
              <i className="fas fa-plug green mr-5"></i>Recommended
            </p>
          </div>
        </div>
        <div className="online-user green">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border green">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="green name-font">User Name</span>
                </li>
                <li className="side-container-user-item">User Job Title</li>
                <li className="side-container-user-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user red">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border red">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="red name-font">User Name</span>
                </li>
                <li className="side-container-user-item">User Job Title</li>
                <li className="side-container-user-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user blue">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border blue">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font">Employer Name</span>
                </li>
                <li className="side-container-user-item">Recruiter Name</li>
                <li className="side-container-user-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user green">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border green">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="green name-font">User Name</span>
                </li>
                <li className="side-container-user-item">User Job Title</li>
                <li className="side-container-user-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user red">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border red">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="red name-font">User Name</span>
                </li>
                <li className="side-container-user-item">User Job Title</li>
                <li className="side-container-user-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user blue">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border blue">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font">Employer Name</span>
                </li>
                <li className="side-container-user-item">Recruiter Name</li>
                <li className="side-container-user-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user green">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border green">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="green name-font">User Name</span>
                </li>
                <li className="side-container-user-item">User Job Title</li>
                <li className="side-container-user-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user red">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border red">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="red name-font">User Name</span>
                </li>
                <li className="side-container-user-item">User Job Title</li>
                <li className="side-container-user-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user blue">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border blue">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font">Employer Name</span>
                </li>
                <li className="side-container-user-item">Recruiter Name</li>
                <li className="side-container-user-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default RecommendedUsers;
